import { useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { Avatar } from '@mui/material';
import axiosInstance, { endpoints } from 'src/utils/axios';
import { useSnackbar } from 'notistack';
import { RouterLink } from 'src/routes/components';
import { LoadingButton } from '@mui/lab';
import { paths } from 'src/routes/paths';
import { createTheme, ThemeProvider } from '@mui/material/styles';

type Props = {
  id?: any;
};

export default function Adminuserviewdetails({ id }: Props) {
  const [data, setData] = useState<any>([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchRole = async () => {
      const token = localStorage.getItem('token');
      if (id) {
        try {
          const res = await axiosInstance.get(
            `${endpoints.admin.getnewsingleadmin}?user_id=${id}`,
            {}
          );
          setData(res.data);
        } catch (error) {
          if (error.error) {
            enqueueSnackbar(error.error, { variant: 'error' });
          } else {
            enqueueSnackbar('Something went wrong. Please try again later', { variant: 'error' });
          }
        }
      }
    };
    fetchRole();
  }, [id, enqueueSnackbar]);

  const theme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            height: '44.9px',
            marginLeft: '2.1px',
          },
          colorPrimary: {
            '&.Mui-checked': {
              // Controls checked color for the thumb
              color: '#ffffff',
            },
          },
          track: {
            // Controls default (unchecked) color for the track
            opacity: 1.7,
            borderRadius: '14px',
            height: '21.2px',
            width: '67px',
            backgroundColor: '#ff0303',
            '.Mui-checked.Mui-checked + &': {
              // Controls checked color for the track
              opacity: 1.7,
              //  width: '58px',
              height: '21.2px',
              width: '66px',
              borderRadius: '14px',

              //  height: '38px',
              backgroundColor: '#2d9668',
            },
          },
        },
      },
    },
  });



  return (
    <Grid container spacing={3}>
      <Grid xs={12} md={4}>
        <Card sx={{ pt: 3, pb: 5, px: 3, height: 250 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Avatar
              alt="Remy Sharp"
              src={data.profile_image_url}
              sx={{ width: 130, height: 130 }}
            />
          </Box>

          <Box sx={{ pl: 8 }}>
            <Grid sx={{ display: 'flex', width: 200 }}>
              <Typography sx={{ pt: 1,ml:7 }}>Status</Typography>{' '}
              {/* <Switch checked={data.is_verified} value={data.is_verified} /> */}
          
          <ThemeProvider theme={theme}>
            <Switch
              sx={{ color: '#c9c9ca', width: '62px' }}
              checked={data.is_verified}
              // onChange={onUpdateStatus}
              value={data.is_verified}
            />
          </ThemeProvider>
        
            </Grid>
          </Box>
        </Card>
      </Grid>

      <Grid xs={12} md={8}>
        <Card sx={{ p: 3, height: 250 }}>
          <Box
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 'bold' }}>User Name</Typography>
              <Typography>{data.username}</Typography>
              <br />
              <Typography sx={{ fontWeight: 'bold' }}>Email</Typography>
              <Typography>{data.email}</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 'bold' }}>User Id</Typography>
              <Typography>{data.user_id}</Typography>
              <br />
              <Typography sx={{ fontWeight: 'bold' }}>Phone No.</Typography>
              <Typography>{data.phone}</Typography>
              <br />
              <br />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <LoadingButton
                component={RouterLink}
                href={paths.dashboard.accessrole.adminUser}
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#5da5da'}}
              >
                Back
              </LoadingButton>
              </Box>
            </Box>
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
}
